import moment from 'moment';
import { TableHeader } from '../../component/table/table.type';
import {
  DeletedHarmReportsKebabOption,
  DeletedHarmReport,
} from './deletedHarmReports.type';
import { camelCase } from 'lodash';
import { OptionWithLoading } from '../userManagement/userManagement.type';

export const getDeletedHarmReportsTableHeader = (
  isTablet: boolean,
  t: (key: string) => string,
) => {
  const headers: TableHeader<DeletedHarmReport>[] = [
    {
      generateCellContent: (report: DeletedHarmReport) =>
        report?.reportRefNo ?? '',
      header: t('harmReports.deletedReports.tableHeader.reportNo'),
      sortable: true,
    },
    {
      generateCellContent: (report: DeletedHarmReport) =>
        report.deletedOn
          ? moment(report.deletedOn).format('hh:mm A, DD/MM/YYYY')
          : '-',
      header: t('harmReports.deletedReports.tableHeader.deletedOn'),
      sortable: false,
    },
    {
      generateCellContent: (report: DeletedHarmReport) =>
        report.playerProfile.id.slice(0, 5),
      header: t('harmReports.deletedReports.tableHeader.playerNo'),
      sortable: false,
    },
    {
      generateCellContent: (report: DeletedHarmReport) =>
        report.playerDetails.description || '-',
      header: t('harmReports.deletedReports.tableHeader.harmObserved'),
      sortable: false,
    },
    {
      generateCellContent: (report: DeletedHarmReport) =>
        report.deletedBy
          ? `${report.deletedBy.firstName} ${report.deletedBy.lastName}`
          : '-',
      header: t('harmReports.deletedReports.tableHeader.deletedBy'),
      sortable: false,
    },
  ];

  return isTablet ? headers.slice(0, headers.length - 1) : headers;
};

export const getDeletedHarmReportsKebabOptions = <
  T,
  Kebabaction extends string = string,
>(
  _deletedHarmReports: T,
  loadingMenu: { rowIndex: number; action: Kebabaction } | null,
  rowIndex: number,
): OptionWithLoading<DeletedHarmReportsKebabOption>[] => {
  const options: OptionWithLoading<DeletedHarmReportsKebabOption>[] = [];
  const addOption = (option: DeletedHarmReportsKebabOption) => {
    options.push({
      label: option,
      value: camelCase(option),
      loading: false,
    });
  };

  Object.values(DeletedHarmReportsKebabOption).forEach((option) => {
    addOption(option);
  });

  return options.map(
    (option: OptionWithLoading<DeletedHarmReportsKebabOption>) => {
      return {
        ...option,
        loading:
          loadingMenu?.rowIndex === rowIndex &&
          loadingMenu?.action === option.value,
      };
    },
  );
};
